interface MetricCardProps {
  label: string;
  badge?: string;
  value: string | number;
  unit?: string;
  detail: string;
  change?: string;
  changeTone?: 'positive' | 'neutral';
}

export function MetricCard({ label, badge, value, unit, detail, change, changeTone = 'neutral' }: MetricCardProps) {
  return (
    <article className="metric-card">
      <div className="metric-top">
        <span className="panel-label">{label}</span>
        {badge && <span className="metric-badge">{badge}</span>}
      </div>
      <div className="metric-value">
        {value}<span>{unit}</span>
      </div>
      <div className="metric-foot">
        <span>{detail}</span>
        {change && <span className={`metric-change ${changeTone}`}>{change}</span>}
      </div>
    </article>
  );
}
